import type { ControlType, FormType } from "../../components/types";

export const getAvailablePairingFormControls = (forms: FormType[]) => {
  const unavailableControls: ControlType[] = [];
  const allControls: ControlType[] = ["beginsWith", "contains", "isEqual"];
  forms.forEach(form => {
    unavailableControls.push(form.control);
  });
  const result = allControls.filter(ac => !unavailableControls.includes(ac));
  return result;
};
